import React, { useState, useEffect, useRef } from "react";
import Countdown from "react-countdown";
import moment from "moment-timezone";

import CountdownRenderer from "./CountdownRenderer";
import { nowMs } from "../../../../common/dateTime";

const NonEnglishAuctionCountdownWrapper = ({
  classes,
  lastUpdatedAmountAt,
  startDateAndTime,
  timeInterval,
  timeZone,
  finalizing,
  onComplete,
}) => {
  const [countdownEndTime, setCountdownEndTime] = useState(null);
  const [key, setKey] = useState(0);
  const [isTransitioning, setIsTransitioning] = useState(false);
  const countdownRef = useRef();

  useEffect(() => {
    const fromTime = lastUpdatedAmountAt || startDateAndTime;
    const endTime = moment(fromTime)
      .add(timeInterval, "minutes")
      .tz(timeZone)
      .toDate();

    // Start transitioning before the countdown actually completes
    setIsTransitioning(true);

    // Force pause the current countdown if it exists
    if (countdownRef.current) {
      countdownRef.current.pause();
    }

    setCountdownEndTime(endTime);
    setKey((prevKey) => prevKey + 1);

    // Small delay to ensure smooth transition
    const timer = setTimeout(() => setIsTransitioning(false), 50);
    return () => clearTimeout(timer);
  }, [lastUpdatedAmountAt, startDateAndTime, timeInterval, timeZone]);

  const handleComplete = () => {
    onComplete();
    setIsTransitioning(true);
  };

  if (!countdownEndTime) return null;

  return (
    <Countdown now={nowMs}
      key={key}
      ref={countdownRef}
      className={classes.bidLive}
      date={countdownEndTime}
      renderer={(...args) =>
        CountdownRenderer(finalizing, ...args, isTransitioning)
      }
      onComplete={handleComplete}
    />
  );
};

export default NonEnglishAuctionCountdownWrapper;
